import {SurveyElement} from '../SurveyModels'

export interface SurveyAnalyticsLog {
  pageId: string
  question: SurveyElement
  direction: 'NEXT' | 'BACK'
}

export interface SurveyAnalyticsData extends SurveyAnalyticsLog {
  sessionId: string
}

export abstract class SurveyAnalytics {
  constructor(protected storageKey: string) {}

  /**
   * You should create new UUID and store it into some storage on the device
   *
   * Example:
   * ```
   * createSession() {
   *   const newSsId = this.createSessionUUID()
   *   myStorage.set('MY_CUSTOM_KEY', newSsId)
   *   return newSsId
   * }
   * ```
   */
  abstract createSession(): string

  /**
   * You Should check if there is already started session, and get the UUID from the storage,
   *
   * If there is not existing session you should create new UUID and store it on the device
   *
   * Example:
   * ```
   * getSessionUUID() {
   *  if myStorage has 'MY_CUSTOM_KEY' then
   *    return myStorage.get('MY_CUSTOM_KEY')
   *  else
   *    return this.createSession()
   * }
   * ```
   */
  abstract getSession(): string

  /**
   * This should be called when we want to destroy or complete concrete session
   */
  abstract completeSession(): void

  /**
   * Pass additional param upon competition
   * @see completeSession
   * @param reason
   */
  abstract completeSessionWithReason<R>(reason: R): void

  /**
   * Should send this data to some STATS API, through the platform API layer /REST, WS, GRAPHQL .../
   * @param data
   */
  abstract sendLog(data: SurveyAnalyticsData): void

  // Expose protected member
  getStorageKey() {
    return this.storageKey
  }

  wrapLogData(stats: SurveyAnalyticsLog) {
    return {
      ...stats,
      sessionId: this.getSession()
    }
  }

  log(stats: SurveyAnalyticsLog) {
    this.sendLog(this.wrapLogData(stats))
  }
}
